import Tooltip from '@material-ui/core/Tooltip';
import MenuSelector from '../../core/MenuSelector';
import WarningIcon from '@material-ui/icons/Warning';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles } from '../style/gstheme';
import { sortByProp } from '../utils/utils';
import TitledPanel from '../TitledPanel';
import cloneDeep from 'lodash/cloneDeep';

const styles = () => {
    return Object.assign({
        infoHeading: {
            display: 'inline-block',
            fontWeight: 500,
            width: 80
        }
    }, globalStyles);
};

class PortSubscriptionDialog extends React.Component {

    constructor(props) {
        super(props);
        const subList = sortByProp(cloneDeep(props.subscriptions), "name");
        this.state = {
            subscriptionToPort: "",
            subList
        };
    }

    portSubscription = () => {
        const { subscriptionToPort } = this.state;
        this.props.onPort({
            subscription: this.props.subscription,
            subscriptionToPort
        });
    };

    exitPortSubscription = () => this.props.onCancel();

    handleSubscriptionChange = (subscriptionToPort) => this.setState({ subscriptionToPort });

    render() {

        const { classes, subscriptions, subscription } = this.props;
        const { subList, subscriptionToPort } = this.state;


        const targetSubscription = subscriptions.find(subItem => subItem.subscription === subscription);
        const portedSubscription = subscriptionToPort ? subscriptions.find(subItem => subItem.subscription === subscriptionToPort) : {};
        const options = subList
            .filter(sub => sub.subscription !== subscription && sub.blocked)
            .map(sub => ({
                value: sub.subscription,
                label: sub.name
            }));

        return (
            <React.Fragment>
                <Dialog className={classes.dialog}
                    open={true}
                    maxWidth="md"
                    fullWidth
                    onClose={this.exitPortSubscription} aria-labelledby="port-subscription-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="port-subscription-dialog-title">Port Subscription</DialogTitle>
                    <DialogContent>
                        <TitledPanel title="Target Subscription">
                            <Typography data-test="target-username" paragraph variant="body2"><span className={classes.infoHeading}>Username</span>{targetSubscription.username}</Typography>
                            <Typography data-test="target-name" paragraph variant="body2"><span className={classes.infoHeading}>Name</span>{targetSubscription.name}</Typography>
                            <Typography data-test="target-iri" paragraph variant="body2"><span className={classes.infoHeading}>IRI</span>{targetSubscription.subscription}</Typography>
                        </TitledPanel>
                        <TitledPanel margin title="Subscription to Port">
                            <div style={{ marginBottom: 12 }}>
                                <MenuSelector
                                    hintWord="subscription"
                                    dataTest="subscription-type"
                                    handleChange={this.handleSubscriptionChange}
                                    selected={subscriptionToPort}
                                    options={options} />
                            </div>
                            <Typography paragraph variant="body2">
                                <span data-test="username" className={classes.infoHeading}>Username</span>
                                {portedSubscription.username}
                                {portedSubscription.username && targetSubscription.username !== portedSubscription.username &&
                                    <span style={{ color: 'red', verticalAlign: 'middle', marginLeft: 12 }}>
                                        <Tooltip title="Usernames are different">
                                            <WarningIcon data-test="warning" />
                                        </Tooltip>
                                    </span>
                                }
                            </Typography>
                            <Typography data-test="iri" paragraph variant="body2"><span className={classes.infoHeading}>IRI</span>{portedSubscription.subscription}</Typography>
                        </TitledPanel>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitPortSubscription} />
                        <PrimaryButton disabled={!subscriptionToPort} onClick={this.portSubscription}>Confirm Port</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

PortSubscriptionDialog.propTypes = {
    classes: PropTypes.object,
    onPort: PropTypes.func.isRequired,
    subscription: PropTypes.string.isRequired,
    subscriptions: PropTypes.array.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default withStyles(styles)(PortSubscriptionDialog);